import { useRef, useState } from 'react';
import { isSupportedIntersectionObserver } from './intersectionObserver';

export const useIntersectionObserver = ({
  root,
  rootMargin,
  threshold,
}: IntersectionObserverInit = {}) => {
  const [entry, setEntry] = useState<IntersectionObserverEntry>();
  const observerRef = useRef(
    isSupportedIntersectionObserver()
      ? new IntersectionObserver(([_entry]) => setEntry(_entry), {
          root,
          rootMargin,
          threshold,
        })
      : null,
  );

  return { entry, observer: observerRef.current };
};
